import { render, staticRenderFns } from "./PivotSortBtn.vue?vue&type=template&id=e3801f08&scoped=true&"
import script from "./PivotSortBtn.vue?vue&type=script&lang=js&"
export * from "./PivotSortBtn.vue?vue&type=script&lang=js&"
import style0 from "./PivotSortBtn.vue?vue&type=style&index=0&id=e3801f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3801f08",
  null
  
)

export default component.exports